import { render } from "./PasswordChangedView.vue?vue&type=template&id=5f199712"
import script from "./PasswordChangedView.vue?vue&type=script&lang=js"
export * from "./PasswordChangedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__